import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import WidthContainer from '../../../components/WidthContainer'

const RootContainer = styled(WidthContainer)`
	max-width: 40rem;
`

const ListContainer = styled.div`
	margin: -0.625rem;
	display: flex;
`

const Tag = styled.div`
	margin: 0.625rem;
	padding: 0.375rem 0.65rem;
	font-size: ${props => props.theme.fontSizes.small};
	background: ${props => props.theme.colors.grayBack};
`

const TagsList = ({className, data}) => <RootContainer className={className}>
	<ListContainer>
		{data.map(one => <Tag>{one}</Tag>)}
	</ListContainer>
</RootContainer>

TagsList.propTypes = {
	className: PropTypes.string,
	data: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
}

TagsList.defaultProps = {
	className: '',
}

export default TagsList
